export default {
  accessToken: null,
  profile: null,
  username: null,
  lastLogin: null
}
